export default __webpack_public_path__ + "static/media/gallery_04.c8572a52.jpg";